var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21824_65808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 6.66675H15L20 11.6667H31.6667C32.5507 11.6667 33.3986 12.0179 34.0237 12.6431C34.6488 13.2682 35 14.116 35 15.0001V28.3334C35 29.2175 34.6488 30.0653 34.0237 30.6904C33.3986 31.3156 32.5507 31.6667 31.6667 31.6667H8.33333C7.44928 31.6667 6.60143 31.3156 5.97631 30.6904C5.35119 30.0653 5 29.2175 5 28.3334V10.0001C5 9.11603 5.35119 8.26818 5.97631 7.64306C6.60143 7.01794 7.44928 6.66675 8.33333 6.66675Z",
    stroke: "#2A3842",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21824_65808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFolder);
export default __webpack_public_path__ + "static/media/iconFolder.1fa66277cb79afd9dcd2bdf5bed52a25.svg";
export { ForwardRef as ReactComponent };